let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kreQr")).then(() => parcelRequire('hfWkk'));